export default __webpack_public_path__ + "static/networkoptimization-background-a89782678780b3e0be6402b121b56ec9.jpg";